import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    minHeight: "100%",
  },

  table: {
    marginBottom: ({ spacing }) => spacing(6),
  },

  cell: {
    border: "none",
  },

  row: {
    borderBottom: "12px solid transparent",
    "&:hover": {
      backgroundColor: "primary.main",

      svg: {
        color: "#ffffff",
      },

      ".MuiAvatar-root": {
        backgroundColor: "#ffffff",
      },
    },
  },

  cellHeader: {
    border: "none",
  },

  text: {
    fontSize: "12px",
  },

  headerLabel: {
    fontSize: "16px",
    color: "text.secondary",
  },

  pagination: {
    ".MuiPaginationItem-root": {
      "&:hover": {
        backgroundColor: "transparent",
      },

      "&.Mui-selected": {
        backgroundColor: "transparent",

        border: "1px solid #5C61FF",
      },
    },
  },

  empty: {
    color: "text.primary",
    textAlign: "center",
  },

  loading: {
    position: "absolute",
    height: "100%",
    width: "100%",
  },
};
